import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4c5ad5bd"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "preview-top"
};
const _hoisted_2 = {
  class: "preview-top-title"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "preview-top-title-text"
}, "Preview", -1));
const _hoisted_4 = {
  class: "preview-tabs"
};
const _hoisted_5 = {
  class: "preview-content"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "preview-placeholder"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_version = _resolveComponent("app-version");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_tabs = _resolveComponent("app-tabs");
  const _component_edit_page_preview_item = _resolveComponent("edit-page-preview-item");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['edit-page-preview', $data.tab])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_app_version, {
    versions: $options.versionList,
    version: $options.updatedProduct,
    onSelect: $options.onSelectVersion
  }, null, 8, ["versions", "version", "onSelect"])]), _createElementVNode("div", {
    class: "preview-top-close",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onClose && $options.onClose(...args))
  }, [_createVNode(_component_app_icon, {
    icon: "cross",
    size: 20,
    color: "#616161"
  })])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_app_tabs, {
    modelValue: $data.tab,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.tab = $event),
    tabs: $data.tabs
  }, null, 8, ["modelValue", "tabs"])]), _createElementVNode("div", _hoisted_5, [$data.tab == 'item' ? (_openBlock(), _createBlock(_component_edit_page_preview_item, {
    key: 0,
    product: $props.product
  }, null, 8, ["product"])) : _createCommentVNode("", true)]), _hoisted_6], 2);
}